// LAYOUT
// ----------------------------------------------------------------------
export const PATH_AFTER_LOGIN = '/dashboard';
export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: localStorage?.getItem('i18nextLng') === 'fa' ? 'rtl' : 'ltr',
  themeColorPresets: 'olive',
  themeLayout: 'horizontal',
  themeStretch: true,
};

export const PaymentDocumentStatuses = [
  { id: 'waitingBankAccount', title: 'waiting-bank-account' },
  { id: 'new', title: 'new' },
  { id: 'canceled', title: 'canceled' },
  { id: 'completed', title: 'completed' },
  { id: 'closed', title: 'closed' },
];
